import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrintRoutingModule } from './print-routing.module';
import { PrintRollsComponent } from './print-rolls/print-rolls.component';
import { PrintLayoutComponent } from './print-layout/print-layout.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PrintCaseSessionsComponent } from './print-case-sessions/print-case-sessions.component';
import { PrintCaseSessionComponent } from './print-case-session/print-case-session.component';
import { PrintExpertSessionComponent } from './print-expert-session/print-expert-session.component';
import { PrintExpertSessionsComponent } from './print-expert-sessions/print-expert-sessions.component';
import { PrintTimesheetComponent } from './print-timesheet/print-timesheet.component';
import { PrintFileSummaryComponent } from './print-file-summary/print-file-summary.component';
import { PrintFilesReportComponent } from './print-files-report/print-files-report.component';
import { PrintClientsComponent } from './print-clients/print-clients.component';
import { PrintClientSummaryComponent } from './print-client-summary/print-client-summary.component';
import { PrintClientContactsComponent } from './print-client-contacts/print-client-contacts.component';
import { PrintClientBankDetailsComponent } from './print-client-bank-details/print-client-bank-details.component';
import { PrintClientContractsComponent } from './print-client-contracts/print-client-contracts.component';
import { PrintClientPartnersComponent } from './print-client-partners/print-client-partners.component';
import { PrintInvoiceSummaryComponent } from './print-invoice-summary/print-invoice-summary.component';


@NgModule({
  declarations: [
    PrintLayoutComponent,
    PrintRollsComponent,
    PrintCaseSessionsComponent,
    PrintCaseSessionComponent,
    PrintExpertSessionComponent,
    PrintExpertSessionsComponent,
    PrintTimesheetComponent,
    PrintFileSummaryComponent,
    PrintFilesReportComponent,
    PrintClientsComponent,
    PrintClientSummaryComponent,
    PrintClientContactsComponent,
    PrintClientBankDetailsComponent,
    PrintClientContractsComponent,
    PrintClientPartnersComponent,
    PrintInvoiceSummaryComponent,
  ],
  imports: [
    CommonModule,
    PrintRoutingModule,
    NgxDatatableModule,
  ],
  exports: [

  ],
  providers: [
  ]
})
export class PrintModule { }
